const ONPREM_PLATFORM_PATHS = new Set([
  "/platform",
  "/platform/onboarding",
  "/platform/logs",
]);

const MANAGED_PLATFORM_PATHS = new Set([
  "/platform",
  "/platform/customers",
  "/platform/onboarding",
  "/platform/billing",
  "/platform/audit",
  "/platform/settings",
]);

export function getPlatformWorkspace(profile) {
  const runtime = profile?.runtime || {};
  const capabilities = profile?.capabilities || {};

  if (runtime.actor_type !== "platform_user") {
    return "tenant";
  }

  if (runtime.deployment_mode === "onprem") {
    return capabilities.can_manage_onprem_onboarding
      ? "onprem"
      : "onprem-unavailable";
  }

  return capabilities.can_access_platform_dashboard ? "managed" : "tenant";
}

export function isPathAllowedForPlatformWorkspace(workspace, pathname) {
  const normalizedPath = String(pathname || "").replace(/\/$/, "") || "/";
  if (workspace === "onprem") {
    return ONPREM_PLATFORM_PATHS.has(normalizedPath);
  }
  if (workspace === "managed") {
    return MANAGED_PLATFORM_PATHS.has(normalizedPath);
  }
  return false;
}
